import { Route, Routes, Outlet } from 'react-router-dom'
import { GruposListWrapper } from './grupos-list/GruposList'
import { PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'

const GruposPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.grupos.descricao')}>{t('menu.grupos')}</PageTitle>
              <GruposListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default GruposPage
